import {Controller} from "@hotwired/stimulus"

/**
 * Controller for handling variant navigation while preserving stone_type selection
 */
export default class extends Controller {

    connect() {
        //console.log("Variant navigator controller connected")
    }

    /**
     * Navigate to a new variant URL while preserving stone_type parameter
     * @param {Event} event - The change event from select
     */
    navigate(event) {
        const baseUrl = event.target.selectedOptions[0]?.dataset.url

        if (!baseUrl) {
            return
        }

        // Get current stone type from the stone type selector if it exists
        const stoneTypeSelect = document.getElementById('stone_type_select')
        if (!stoneTypeSelect) {
            window.location = baseUrl
            return
        }

        // Get parameterized format from selected option's data-param attribute
        const selectedOption = stoneTypeSelect.selectedOptions[0]
        const stoneTypeParam = selectedOption?.dataset.param || stoneTypeSelect.value

        // Build URL with stone_type parameter if present
        let finalUrl = baseUrl
        if (stoneTypeParam) {
            const separator = baseUrl.includes('?') ? '&' : '?'
            finalUrl = `${baseUrl}${separator}stone_type=${stoneTypeParam}`
        }

        // Navigate to the new URL
        window.location = finalUrl
    }
}
